import { render, staticRenderFns } from "./dashboard-certificates.vue?vue&type=template&id=40ab8b71&scoped=true&"
import script from "./dashboard-certificates.vue?vue&type=script&lang=js&"
export * from "./dashboard-certificates.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-certificates.vue?vue&type=style&index=0&id=40ab8b71&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ab8b71",
  null
  
)

export default component.exports